import React from 'react'
import Header from '../../header'
import Banner from './banner';
import PreBookingPromo from './prebooking';
import Story from './story';
import Franchise from './franchise';
import WhyChoose from './why_choose';
import GetFranchise from './get-franchise';
import Investment from './investment';
import Works from './works';
import OurProducts from './our-products';
import Testimonial from './testimonial';
import Faq from './faq';
import Disclaimer from './disclaimer';
import Contact from './contact';
import Footer from '../../footer';

export default function Home() {

    return (
        <div className='relative overflow-hidden'>
            <Header />
            <Banner />
            <PreBookingPromo />
            <Story />
            <Franchise />
            <WhyChoose />
            <GetFranchise />
            <Investment />
            <Works />
            <OurProducts/>
            <Testimonial />
            <Faq/>
            <Disclaimer />
            <Contact />
            <Footer />
        </div>
    )
}
